var internet = {};
module['exports'] = internet;
internet.free_email = require("./free_email");
internet.domain_suffix = require("./domain_suffix");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/fr/internet/index.js
 ** module id = 581
 ** module chunks = 0
 **/